import { render, staticRenderFns } from "./VaimoLink.vue?vue&type=template&id=d51ecbb4&scoped=true&"
import script from "./VaimoLink.vue?vue&type=script&lang=js&"
export * from "./VaimoLink.vue?vue&type=script&lang=js&"
import style0 from "./VaimoLink.vue?vue&type=style&index=0&id=d51ecbb4&prod&lang=scss&scoped=true&"
import style1 from "./VaimoLink.vue?vue&type=style&index=1&id=d51ecbb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51ecbb4",
  null
  
)

export default component.exports